import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import { Helmet } from "react-helmet";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
// updateAuthentication
import { instance } from "../../../../Actions/AxiosInstance";
import { updateSubscriptionInfo } from "../../../../Actions/SubscriptionInfo";
import { updateAuthentication } from "../../../../Actions/AuthenticationAction";
import If from "../../../../Component/Common/If";
import createstore from "../../../../store";
//import EducationTabs from "../EducationTabs";
import WorkExperienceTabs from "../WorkExperienceTabs";
import {
  profilePrivacyInfo,
  CheckActionPermission,
} from "../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../Actions/LanguageAction";
import { ReducersTypes } from "../../../../Constants";
import EmpProfile from "./EmpProfile";
import EmpActions from "./EmpProfile/EmpActions";
import EmpTeam from "./EmpTeam";
//import PoliciesTabs from "../PoliciesTabs";
import ProfileTabs from "./ProfileTabs";
//import AssetTabs from "../AssetsTabs";
import headersList from "../../../../Constants/headersList";
import DocumentationTabs from "../DocumentationTabs";
import { NoRecordFound } from "./NoRecordFound";
import "./index.css";
//import CommonNavbar from "../../CommonLayout/Navbar";
import { backToHome } from "../../../../Handlers/setters";
import MainAdvancePage from "./MainAdvancePage";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import JupiterMandate from "./JupiterMandate";

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} className="ver-tab-padding">
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(45deg)",
  },
});

class MainProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openList: true,
      editQuote: false,
      value: 0,
      fields: {
        backgroundImage: "",
      },
      dropdown: [
        { displayvalue: 1, displayname: "Mobile Number" },
        { displayvalue: 2, displayname: "Email Id" },
      ],
      Modules: ["empprofile"],
      ProfileBasicInfo: {},
      privacyData: [],
      myProfile: [
        { privacymenuid: 100, isprivacy: true },
        { privacymenuid: 200, isprivacy: true },
        { privacymenuid: 300, isprivacy: true },
        { privacymenuid: 400, isprivacy: true },
        { privacymenuid: 500, isprivacy: true },
        { privacymenuid: 600, isprivacy: true },
        { privacymenuid: 700, isprivacy: true },
      ],
      colleagueProfile: [],
      hideButton: false,
      employeeid: "",
      colleagueid: null,
      permissions: { readOnly: false, editable: false },
      showHideComp1: false, 
      ismandate:false,
      isjupiterbank : false,
  };  
  this.hideComponent = this.hideComponent.bind(this); 
  }

  hideComponent(name) {  
    console.log(name);  
    switch (name) {  
        case "showHideComp1":  
            this.setState({ showHideComp1: !this.state.showHideComp1 });  
            break;  
        default:  
            null;  
    }  
}

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("profile");
    if (isTrue) {
      this.setState({ permissions });
      window.scrollTo(0, 0);

      if (this.props.history.location.hash == "#policies") {
        this.setState({ value: 5 });
      } else if (this.props.history.location.hash == "#assets") {
        this.setState({ value: 4 });
      } else {
        this.setState({ value: this.state.value });
      }
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  handleChange = (event, value) => {

    this.setState({ value });

    window.location.hash = "";
  };

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };
  
  componentWillMount() {
    const [isTrue] = CheckActionPermission("profile");
    if (isTrue) {
      // this.setState({ permissions });
      this.props.ChangeLanguage("empprofile,emppersonaltab");
      const [actualpermissions] = CheckActionPermission("profile");
      const { AuthenticationAction, SubscriptionData } = this.props;
      let {
        subscriptionname,
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
      } = SubscriptionData;
      if (!AuthenticationAction.IsFulfilled && !employeeid) {
        // this.props.history.push("404");
        // this.props.enqueueSnackbar("You don't have access to this page", {
        //   variant: "error",
        // });
        this.setState({ permissiondenied: true });
      } else if (
        get(this.props, "history.location.pathname", "").includes(
          "/newemployee",
        ) &&
        AuthenticationAction.login
      ) {
        this.props.updateAuthentication("LOGIN_UPDATED_WITH_ISFULFILLED", {
          IsFulfilled: false,
          data: null,
        });
        backToHome();
      }
      if (AuthenticationAction.IsFulfilled) {
        employeeid = AuthenticationAction.login.employeeid;
      }
      const masterprofileid = get(
        AuthenticationAction,
        "login.masterprofileid",
        9,
      );
      const { colleagueid } = this.props.match.params;
      let hideButton;
      colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false);
      
      let value =0;
        // colleagueid && colleagueid != employeeid
        // ? masterprofileid != 9
        //   ? (value = 1)
        //   : (value = 0)
        // : (value = 0);
      let { permissions } = this.state;
      /* get(this.props, "AuthenticationAction.login.masterprofileid", "") == 9 || */ !colleagueid ||
      colleagueid == employeeid
        ? (permissions = actualpermissions)
        : (permissions = { readOnly: false, editable: false });
      this.setState(
        {
          colleagueid,
          subscriptionname,
          accountid,
          subscriptionid,
          countrytimezoneid,
          employeeid,
          permissions,
          showProfileStrength: get(
            this.props,
            "history.location.pathname",
            "",
          ).includes("/newemployee"),
          hideButton,
          value,
        },
        () => {
          this.GetProfileBasicInfo();
          this.GetPrivacyInfo();
          this.GetProfileStrength();
          this.GetJupiterMandate();
          this.GetAllBankingDetails();
          // this.setState({ showProfileStrength: false });
        },
      );
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  GetAllBankingDetails() {
    const URL = "employee/getempallbankdetail";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        if (result.data.result.length > 0) {
          const empbank = result.data.result.filter((x) => x.isdefault == true && (x.banknameid == 16 || x.banknameid == 88));
          this.setState({
            isjupiterbank: (empbank && empbank.length > 0 ) ? true : false,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetJupiterMandate(){
    const URL = `/jupiteroffer/jupiter-mandate`;
    instance
    .get(URL)
    .then((result) => {
      console.log("jupiter",result);
     this.setState({ ismandate: (result.data.result.length > 0 ? result.data.result[0].ismandate : false)});
    })
    .catch((error) => {
      const CommonError = error.response
        ? error.response.data.error.message
        : error.message;
      this.props.enqueueSnackbar(CommonError, { variant: "error" });
    });

  }

  GetPrivacyInfo() {
    if (this.state.colleagueid) {
      const URL = `/users/empprofileprivacy/${this.state.colleagueid}`;
      instance
        .get(URL)
        .then((result) => {
          let colleagueProfile = [];
          result.data.result.length > 0
            ? (colleagueProfile = result.data.result)
            : (colleagueProfile = []);

          const maintabs = colleagueProfile.filter(
            (tab) =>
              tab.privacymenuid == 100 ||
              tab.privacymenuid == 200 ||
              tab.privacymenuid == 300 ||
              tab.privacymenuid == 400 ||
              tab.privacymenuid == 500 ||
              tab.privacymenuid == 600 ||
              tab.privacymenuid == 700,
          );
          const roottabs = maintabs.filter((tabs) => !tabs.isprivacy);
          this.setState({ colleagueProfile, roottabs });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      const { myProfile } = this.state;
      this.setState({ myProfile });
      this.GetProfileBasicInfo();
    }
  }

  CheckPrivacy(compId) {
    let result;
    if (!get(this.props, "AuthenticationAction.login", "")) {
      return true;
    }
    const { masterprofileid } = this.props.AuthenticationAction.login;
    if (
      this.state.colleagueid &&
      this.state.colleagueid != this.state.employeeid &&
      masterprofileid != 9
    ) {
      result = this.state.colleagueProfile;
      const info = result.find((x) => x.privacymenuid == compId);
      if (info) {
        if (info.isprivacy) {
          return false;
        }
        return true;
      }
      return false;
    }
    result = this.state.myProfile;
    const info = result.find((x) => x.privacymenuid == compId);
    if (info.isprivacy) {
      return true;
    }
    return false;
  }

  OpenEmpList() {
    this.setState({ openList: !this.state.openList });
  }

  IamDone() {
    const data = {
      accountid: this.state.accountid,
      subscriptionid: this.state.subscriptionid,
      timezoneid: this.state.countrytimezoneid,
      employeeid: this.state.employeeid,
      sendersourceid: 1,
      // "comment": "req.body.comment"
    };
    const URL = "subscription/sendprospectrequest";
    instance
      .post(URL, data)
      .then((res) => {
        const result = {
          data: {
            result: [],
          },
        };
        const employeeid = "";
        const info = createstore.getState().SubscriptionInfo.SubscriptionData;
        result.data.result[0] = Object.assign(info, { employeeid });
        this.props.updateSubscriptionInfo(
          `${ReducersTypes.SUBSCRIPTIONINFO}_FULFILLED`,
          result,
        );
        this.props.enqueueSnackbar("saved successfully", {
          variant: "success",
        });
        this.props.history.push(`/newemployee`);
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetProfileStrength() {
    const URL = "/employee/getempprofileconfigpercentage";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      data = {};
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let ProfileStrength;
        result.data.result.length > 0
          ? (ProfileStrength = result.data.result[0])
          : (ProfileStrength = {});
        const { configpercentage } = ProfileStrength;
        this.setState({ configpercentage });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdateStrength = (flag) => {
    if (flag == true) {
      this.GetProfileStrength();
    }
  };

  GetProfileBasicInfo() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let ProfileBasicInfo = [];
        result.data.result.length != 0
          ? (ProfileBasicInfo = result.data.result[0])
          : (ProfileBasicInfo = []);
        const { mythought } = ProfileBasicInfo;
        this.setState({ mythought });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  EditQuote() {
    this.setState({ editQuote: true });
  }

  CancelUpdatingQuote() {
    this.setState({ editQuote: false });
  }

  onChangeQuote(e) {
    this.setState({ mythought: e.target.value });
  }

  // getBackgroundImg(IMG, imgname, HtField, files) {

  //     let reader = new FileReader();
  //     reader.readAsDataURL(files[0]);
  //     // alert(reader.readyState)
  //     reader.onload = () => {
  //         // alert(reader.readyState)
  //         let fields = this.state.fields;
  //         // fields[IMG] = files.name;
  //
  //         fields[imgname] = reader.result;
  //     }
  // }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  UpdateQuote() {
    const data = {
      mythought: this.state.mythought,
    };
    if (!createstore.getState().AuthenticationAction.IsFulfilled) {
      Object.assign(data, {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      });
    }
    const URL = "employee/updatethought";
    instance
      .post(URL, data)
      .then((result) => {
        this.setState({ editQuote: false });
        this.props.enqueueSnackbar("saved successfully", {
          variant: "success",
        });
        this.GetProfileStrength();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const { classes, theme } = this.props;
    const { permissions, roottabs, myProfile, hideButton } = this.state;
    const { showHideComp1 } = this.state;
    const language = this.props.Language.empprofile;

    const flag = 1;

    // const language = this.props.Language[Modules[value]];
    const value = Number(this.state.value);
    return (
      <div className="application">
        <Helmet>
          <title>{headersList.Profile.header}</title>
        </Helmet>
        <IntlProvider locale="en" messages={language}>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <main className="content-outer-wrapper">
              <div className="main-profile-outer display-block">
                {this.state.showProfileStrength ? (
                  <div>
                    <Grid container className="width100 employe-status-dection">
                      <Grid item xs={12} sm={6} md={8}>
                        <div className="padding20">
                          <div className="emp-add-head">
                            <FormattedMessage
                              id="LbAddingYourselfEmployee"
                              defaultMessage="You are adding yourself as an employee of"
                            />
                            {`  ${this.state.subscriptionname}`}
                          </div>
                          <p className="emp-add-desc">
                            <FormattedMessage
                              id="_LbCompleteBelowProfile"
                              defaultMessage="Please complete the below profile completely and click on “Let me in” button on this bar."
                            />
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={3} md={2}>
                        <div className="employ-processbar-status">
                          {this.state.configpercentage} %
                        </div>
                        <LinearProgress
                          variant="determinate"
                          value="20"
                          className="emp-process-bar"
                        />
                        <div className="employ-processbar-desc">
                          <FormattedMessage
                            id="LbProfileStrength"
                            defaultMessage="Profile Strength"
                          />
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={3}
                        md={2}
                        align="center"
                        className="padding-top-10"
                      >
                        <div
                          color="primary"
                          className="form-btn"
                          onClick={this.IamDone.bind(this)}
                        >
                          {/* <FormattedMessage id="BtI'mDone" defaultMessage="Let me in" /> */}
                          <span>Let me in</span>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
                {/* Main Profile Grid */}
                <Grid
                  container
                  className={
                    this.state.showProfileStrength
                      ? "emp-profile-page-landing"
                      : " "
                  }
                >
                  <Grid
                    item
                    xs={12}
                    md={3}
                    sm={12}
                    className="FixedProfile nav-top-fixed1 top-profile"
                  >
                    {/* nav-top-fixed */}

                    <EmpProfile
                      OpenEmpList={this.OpenEmpList.bind(this)}
                      colleagueid={this.state.colleagueid}
                      {...this.props}
                      permissions={permissions}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sm={12}
                    className="FixedProfile nav-top-fixed1 top-profile"
                  >
                   
                   {this.state.openList && !hideButton? (
                        <div>
                          {!this.state.showProfileStrength && this.state.ismandate && !this.state.isjupiterbank && (
                            <JupiterMandate
                              colleagueid={this.state.colleagueid}
                              ismandate={this.state.ismandate}
                              {...this.props}
                              UpdateStrength={this.UpdateStrength}
                            />
                          )}
                        </div>
                      ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    sm={12}
                    className="main-emp-profile-section nav-left"
                  >
                    <div className="emp-section-innerwrapper padding-top-0 mainprofile-minheight">

                      {this.state.openList && !hideButton? (
                        <div>
                          {!this.state.showProfileStrength && (
                            <EmpTeam
                              colleagueid={this.state.colleagueid}
                              ismandate={this.state.ismandate}
                              {...this.props}
                              UpdateStrength={this.UpdateStrength}
                            />
                          )}
                        </div>
                      ) : null}
                      <div>
                        <AppBar
                          position="static"
                          color="default"
                          className="margin-bottom-20 margin-top-20"
                        >
                          <Paper>
                            <Tabs
                              onChange={this.handleChange}
                              value={value}
                              indicatorColor="primary"
                              textColor="primary"
                            >
                              {/* {this.CheckPrivacy(100) && */}
                              <Tab
                                className={
                                  !this.CheckPrivacy(100) && "displaynone"
                                }
                                label={
                                  <FormattedMessage
                                    id="TabPersonal__"
                                    defaultMessage="Personal Data"
                                  />
                                }
                                // onClick={() => this.handleChange("dashboard")}
                              />
                              {/* {this.CheckPrivacy(200) && */}
                              <Tab
                                className={
                                  !this.CheckPrivacy(200)
                                    ? "displaynone"
                                    : "Work-Profile"
                                }
                                label={
                                  <FormattedMessage
                                    id="_TabWorkProfile"
                                    defaultMessage="Work Profile"
                                  />
                                }
                              />
                              {/* {this.CheckPrivacy(300) && */}
                              {/* <Tab
                                className={
                                  !this.CheckPrivacy(300)
                                    ? "displaynone"
                                    : "Education"
                                }
                                label={
                                  <FormattedMessage
                                    id="TabEducation"
                                    defaultMessage="Education"
                                  />
                                }
                              /> */}

                              {/* {this.CheckPrivacy(400) && */}
                              <Tab
                                className={
                                  !this.CheckPrivacy(400)
                                    ? "displaynone"
                                    : "documents"
                                }
                                label={
                                  <FormattedMessage
                                    id="TabDocument"
                                    defaultMessage="Documents"
                                  />
                                }
                              />
                              {/* <Tab
                                className={
                                  !this.CheckPrivacy(600)
                                    ? "displaynone"
                                    : "documents"
                                }
                                label={
                                  <FormattedMessage
                                    id="TabAsset"
                                    defaultMessage="Assets"
                                  />
                                }
                              /> */}
                              {/* {this.props.AuthenticationAction.login
                                .masterprofileid == 9 && (
                                <Tab
                                  className={
                                    !this.CheckPrivacy(500)
                                      ? "displaynone"
                                      : "documents"
                                  }
                                  label="Policies"
                                />
                              )} */}
                            </Tabs>
                          </Paper>
                        </AppBar>
                        {!hideButton ? (
                          <Paper>
                            <SwipeableViews
                              axis={
                                theme.direction === "rtl" ? "x-reverse" : "x"
                              }
                              index={value}
                              onChangeIndex={this.handleChangeIndex}
                              className="nopadding"
                              animateTransitions={false}
                              style={{ overflowX: "unset" }}
                            >
                              <If condition={value == 0}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  <ProfileTabs
                                    colleagueid={this.state.colleagueid}
                                    {...this.props}
                                    permissions={permissions}
                                    UpdateStrength={this.UpdateStrength}
                                  />
                                </TabContainer>
                              </If>
                              <If condition={value == 1}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  <WorkExperienceTabs
                                    colleagueid={this.state.colleagueid}
                                    {...this.props}
                                    permissions={permissions}
                                    UpdateStrength={this.UpdateStrength}
                                  />
                                </TabContainer>
                              </If>
                              {/* <If condition={value == 2}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  <EducationTabs
                                    colleagueid={this.state.colleagueid}
                                    {...this.props}
                                    permissions={permissions}
                                    UpdateStrength={this.UpdateStrength}
                                  />
                                </TabContainer>
                              </If> */}
                              <If condition={value == 2}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  <DocumentationTabs
                                    colleagueid={this.state.colleagueid}
                                    {...this.props}
                                    permissions={permissions}
                                    UpdateStrength={this.UpdateStrength}
                                  />
                                </TabContainer>
                              </If>
                              {/* <If condition={value == 4}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  <AssetTabs
                                    colleagueid={this.state.colleagueid}
                                    {...this.props}
                                    permissions={permissions}
                                    UpdateStrength={this.UpdateStrength}
                                  />
                                </TabContainer>
                              </If> */}

                              {/* {this.props.AuthenticationAction.login
                                .masterprofileid == 9 && (
                                <If condition={value == 5}>
                                  <TabContainer
                                    dir={theme.direction}
                                    className="nopadding"
                                  >
                                    <PoliciesTabs
                                      colleagueid={this.state.colleagueid}
                                      {...this.props}
                                      permissions={permissions}
                                      UpdateStrength={this.UpdateStrength}
                                    />
                                  </TabContainer>
                                </If>
                              )} */}
                            </SwipeableViews>
                          </Paper>
                        ) : (
                          <Paper style={{ height: 600, position: "relative" }}>
                            <SwipeableViews
                              axis={
                                theme.direction === "rtl" ? "x-reverse" : "x"
                              }
                              index={value}
                              onChangeIndex={this.handleChangeIndex}
                              className="nopadding"
                              animateTransitions={false}
                              style={{ overflowX: "unset" }}
                            >
                              <If condition={value == 0}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  {this.CheckPrivacy(100) ? (
                                    <ProfileTabs
                                      colleagueid={this.state.colleagueid}
                                      {...this.props}
                                      permissions={permissions}
                                      UpdateStrength={this.UpdateStrength}
                                    />
                                  ) : (
                                    // <div
                                    //   style={{
                                    //     textAlign: "center",
                                    //     marginTop: 250,
                                    //     overflow: "hidden",
                                    //     fontSize: 20
                                    //   }}
                                    // >

                                    //   No records found
                                    // </div>
                                    <NoRecordFound />
                                  )}
                                </TabContainer>
                              </If>
                              <If condition={value == 1}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  {this.CheckPrivacy(200) ? (
                                    <WorkExperienceTabs
                                      colleagueid={this.state.colleagueid}
                                      {...this.props}
                                      permissions={permissions}
                                      UpdateStrength={this.UpdateStrength}
                                    />
                                  ) : (
                                    <NoRecordFound />
                                  )}
                                </TabContainer>
                              </If>
                              {/* <If condition={value == 2}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  {this.CheckPrivacy(300) ? (
                                    <EducationTabs
                                      colleagueid={this.state.colleagueid}
                                      {...this.props}
                                      permissions={permissions}
                                      UpdateStrength={this.UpdateStrength}
                                    />
                                  ) : (
                                    <NoRecordFound />
                                  )}
                                </TabContainer>
                              </If> */}
                              <If condition={value == 2}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  {this.CheckPrivacy(400) ? (
                                    <DocumentationTabs
                                      colleagueid={this.state.colleagueid}
                                      {...this.state}
                                      {...this.props}
                                      permissions={permissions}
                                      UpdateStrength={this.UpdateStrength}
                                    />
                                  ) : (
                                    <NoRecordFound />
                                  )}
                                </TabContainer>
                              </If>
                              {/* <If condition={value == 4}>
                                <TabContainer
                                  dir={theme.direction}
                                  className="nopadding"
                                >
                                  {this.CheckPrivacy(600) ? (
                                    <AssetTabs
                                      colleagueid={this.state.colleagueid}
                                      {...this.state}
                                      {...this.props}
                                      permissions={permissions}
                                      UpdateStrength={this.UpdateStrength}
                                    />
                                  ) : (
                                    <NoRecordFound />
                                  )}
                                </TabContainer>
                              </If> */}

                              {/* {this.props.AuthenticationAction.login
                                .masterprofileid == 9 && (
                                <If condition={value == 5}>
                                  <TabContainer
                                    dir={theme.direction}
                                    className="nopadding"
                                  >
                                    {this.CheckPrivacy(500) ? (
                                      <PoliciesTabs
                                        colleagueid={this.state.colleagueid}
                                        {...this.state}
                                        {...this.props}
                                        permissions={permissions}
                                        UpdateStrength={this.UpdateStrength}
                                      />
                                    ) : (
                                      <NoRecordFound />
                                    )}
                                  </TabContainer>
                                </If>
                              )} */}
                            </SwipeableViews>
                          </Paper>
                        )}
                      </div>
                    </div>
                  </Grid>
                </Grid>

                {/* new code passward set, reactivate emp,initiate regisnation start */}
                {!hideButton && (
                <div>
                {/* <Paper className="padding20" > */}
                <EmpActions
                  OpenEmpList={this.OpenEmpList.bind(this)}
                  colleagueid={this.state.colleagueid}
                  {...this.props}
                  permissions={permissions}
                />
                 {/* </Paper> */}
                </div> )}
                {!hideButton && (
                <div className="margin-bottom-20" style={{marginTop:10}}>
                {/* <button href="#anchor1" style={{scrollBehavior: "smooth"}} className="btn btn-secondary-sm-green scrollLink" onClick={() => this.hideComponent("showHideComp1")}>  
                  Advanced </button>  */}
                  <Grid item xs={12} md={12} sm={12}>
                          <span
                             // className="rounded-rectangle-div"
                              style={{
                                padding: "8px 29px",
                                margin: "16px -29px",
                                width: 195,
                                display: "flex",
                                //height: 25,
                                alignItems: "center",
                                cursor: "pointer",
                                float:"left",
                                textDecoration:"underline",
                                display:"inline-block",
                                
                              }}
                              onClick={() => this.hideComponent("showHideComp1")}
                              //onClick={() => this.openOptions(true)}
                            >
                              <p className="normal-dark-secondary">
                               
                              <InputAdornment position="end">
                              Additional profile details
                                  <IconButton
                                    className="ShowPassword"
                                    aria-label="Toggle password visibility"
                                    //onClick={this.handleClickShowLogDetail}
                                    style={{ textDecoration:"underline",
                                      display:"inline-block"}}
                                  >
                                    {this.state.showHideComp1 ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              </p>
                          </span>
                          </Grid> 
                 
                    {showHideComp1 && (
                    <div>
                      {!this.state.showProfileStrength && (
                        <MainAdvancePage
                          colleagueid={this.state.colleagueid}
                          {...this.props}
                          ismandate={this.state.ismandate}
                        />
                      )}
                    </div>
                    )}
                </div> )}
               
                {/* new code Advance end */}
               
            </div>
              
            </main>
          )} 
        </IntlProvider>
      </div>
    );
  }
}

MainProfilePage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateAuthentication,
      ChangeLanguage: (data) => ChangeLanguage(data),
      profilePrivacyInfo: (data) => profilePrivacyInfo(data),
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
    },
    dispatch,
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles, { withTheme: true })(withSnackbar(MainProfilePage))),
);
